module.exports = __webpack_public_path__ + "img/教育与培训.0eb25035.png";